import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Login.css';

const LoginPage = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const from = location.state?.from?.pathname || '/admin';

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleGoogleSuccess = (credentialResponse) => {
    const { credential } = credentialResponse;
    const { email, name, picture } = jwtDecode(credential);
    
    fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ idToken: credential }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Login failed: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // Use the server token for client session
        login(data.token, { email, name, picture });
        navigate(from, { replace: true });
      })
      .catch(error => {
        console.error('Google login error:', error);
        alert('Google login failed: ' + error.message);
      });
  };

  return (
    <div className="login-container">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <title>Admin Login - Rocket League Esports</title>
      </Helmet>
      <div className="login-card">
        <h2>Admin Login</h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px', fontSize: '14px' }}>
          Sign in with your Google account
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin onSuccess={handleGoogleSuccess} />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
